import { IVehicle } from 'src/app/models';

export const initialVehiclesState: IVehicle = {
  name: '',
  availableSeats: 0,
  prmAvailableSeats: 0,
  convertibleSeats: [],
  active: true,
  operator: undefined
};
